module.exports = require("colors");


//////////////////
// WEBPACK FOOTER
// external "colors"
// module id = 178
// module chunks = 0